import { parseJSON } from 'date-fns';
import { format } from 'date-fns/esm';
import _ from 'lodash';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { MdDone, MdDoneAll, MdInfo } from 'react-icons/md';
import { RiSendPlaneFill } from 'react-icons/ri';
import { useLocation } from 'react-router-dom';
import { io } from 'socket.io-client';
import { BACK_ARROW, DEFAULT_PROFILE_PIC } from '../../assets/icons';
import { useAppSelector } from '../../hooks/useRedux';
import { API_URL } from '../../utils/constants';
import xhr from '../../utils/fetch';
import { NO_MESSAGES } from '../../assets/images';
import { SEO } from '../../components/SEO';

interface Messsage {
  _id: string;
  content: string;
  senderId: string;
  receiverId: string;
  status: 'pending' | 'delivered' | 'read';
  createdAt: string;
  read: boolean;
}
interface ConversationItem {
  _id?: string;
  users?: string[];
  recentMessage: Messsage | null;
  user: {
    _id: string;
    name: string;
    profilePic: string;
  };
  createdAt: string;
}
var socket = io(API_URL!, { autoConnect: false });

export default function Inbox() {
  const { userData: user } = useAppSelector((state) => state.userSlice);
  const [selectedChat, setSelectedChat] = useState<ConversationItem>();
  const [sessionDetails, setSessionDetails] = useState<{ status?: 'online' | 'offline'; lastSeen?: string }>();
  const [users, setUsers] = useState<ConversationItem[]>([]);
  const location = useLocation();
  const [messages, setMessages] = useState<Messsage[]>([]);
  const [message, setMessage] = useState('');
  const [conversations, setConversations] = useState<ConversationItem[]>([]);
  const [searchResults, setSearchResults] = useState<ConversationItem[]>([]);
  const chatBoxRef = useRef<HTMLDivElement>(null);
  const [messagesByDate, setMessagesByDate] = useState<{ date: string; messages: Messsage[] }[]>([]);


  const scrollToBottom = () => {
    if (chatBoxRef.current) {
      const height = chatBoxRef.current?.scrollHeight;
      if (height) {
        chatBoxRef.current.scrollTo({ top: height });
      }
    }
  };


  const getConversationUsers = () => {
    xhr({
      url: `/${user?._id}/conversations`,
      method: 'GET'
    })
      .then((res) => {
        if (res.status === 'OK') {
          setConversations(res.data);
          if (!selectedChat?._id && selectedChat?.user) {
            let x = res.data.find((item: any) => item.user._id === selectedChat.user._id);
            if (x) {
              setSelectedChat(x);
            }
          }
        }
      })
      .catch((err) => err);
  };

  const getSessionDetails = () => {
    if (selectedChat) {
      xhr({
        url: `/user-chat-session?id=${selectedChat.user._id}`,
        method: 'GET'
      })
        .then((res) => {
          if (res.status === 'OK' && res.data) {
            if (res.data._id) {
              setSessionDetails(res.data);
            }
          } else {
            setSessionDetails(undefined);
          }
        })
        .catch((err) => err);
    }
  };

  const getMessages = () => {
    xhr({
      url: `/${user?._id}/conversations/${selectedChat?._id}/messages`,
      method: 'GET'
    })
      .then((res) => {
        if (res.status === 'OK') {
          setMessages(res.data);
        }
      })
      .catch((err) => err);
  };

  const readMessages = () => {
    const unreadMsgs = messages.filter((m) => m.senderId !== user?._id && m.read === false);
    console.log(unreadMsgs);
    if (unreadMsgs.length === 0) return;
    socket.emit("read", {
      from: user?._id,
      to: unreadMsgs[0].senderId,
      msgIds: unreadMsgs.map((m) => m._id)
    })
    // xhr({
    //   url: `/messages/read`,
    //   method: 'PUT',
    //   body: { messageIds: unreadMsgs.map((m) => m._id) }
    // })
    //   .then((res) => {
    //     if (res.status === 'OK') {
    //       // read the recent Message
    //       const c = [...conversations];
    //       const cIndex = conversations.findIndex((c) => c._id === selectedChat?._id);
    //       const msg = c[cIndex].recentMessage;
    //       if (msg) {
    //         c[cIndex] = { ...c[cIndex], recentMessage: { ...msg, read: true } };
    //       }
    //       setConversations(c);
    //       // TODO: read all local messages
    //     }
    //   })
    //   .catch((err) => err);
  };

  const disconnect = () => {
    socket.disconnect();
  };

  const sendMessage = () => {
    if (!message) {
      return;
    }
    if (selectedChat?.user._id) {
      socket.emit('msg', {
        content: message,
        to: selectedChat?.user._id
      });
      setMessage('');
    }
  };

  useEffect(() => {
    console.log("INSIDE", messages.length);
    // this gives an object with dates as keys
    const groupedMessages = messages.reduce((messages, message) => {
      const date = message.createdAt.split('T')[0];
      // @ts-ignore
      if (!messages[date]) {
        // @ts-ignore
        messages[date] = [];
      }
      // @ts-ignore
      messages[date].push(message);
      return messages;
    }, {});

    // Edit: to add it in the array format instead
    const groupArrays = Object.keys(groupedMessages).map((date) => {
      return {
        date,
        // @ts-ignore
        messages: groupedMessages[date]
      };
    });
    // @ts-ignore
    setMessagesByDate(groupArrays);
  }, [messages]);

  useLayoutEffect(() => {
    scrollToBottom();
  }, [messagesByDate]);

  useEffect(() => {
    if (messages.length > 0) {
      readMessages();
    }
  }, [messages]);

  useEffect(() => {
    if (selectedChat?._id) {
      getSessionDetails();
      getMessages();
    }
  }, [selectedChat]);

  useEffect(() => {
    disconnect();
    if (user) {
      socket.auth = { userId: user._id };
      socket.connect();
      getConversationUsers();
    }
    if (location.state) {
      const cItem = {
        recentMessage: null,
        user: {
          _id: location.state._id,
          name: location.state.name,
          profilePic: location.state.profilePic
        },
        createdAt: new Date().toISOString()
      };
      setSelectedChat(cItem);
      if (conversations.findIndex((u) => u._id === cItem.user._id) < 0) {
        setUsers([cItem, ...users]);
      }
    }

    return () => {
      disconnect();
    };
  }, []);

  useEffect(() => setSearchResults(conversations), [conversations]);

  socket.on('msg', function (msg) {
    // Current user is Sender and receiver chat is open
    // ---------------  Acknowlegement of sent message -------------------
    if (selectedChat?.user._id == msg.receiverId && user?._id == msg.senderId) {
      setMessages([...messages, msg]);
      const c = [...conversations];
      const cIndex = conversations.findIndex((c) => c.user._id === msg.receiverId);
      if (cIndex > -1) {
        c[cIndex] = { ...c[cIndex], recentMessage: msg };
        const sorted = _.sortBy(c, (e) => e.recentMessage?.createdAt);
        setConversations(sorted.reverse());
      } else {
        if (selectedChat) {
          getConversationUsers();
        }
      }
      // socket.emit('read', {
      //   from: user?._id,
      //   to: msg.senderId
      // });
      return;
    }
    // if the guy whose chat i've opened has sent a message
    if (selectedChat?.user._id == msg.senderId && user?._id == msg.receiverId) {
      setMessages((prev) => [...messages, msg]);
      // change conversation recent message
      const c = [...conversations];
      const cIndex = conversations.findIndex((c) => c.user._id === msg.senderId);
      if (cIndex > -1) {
        c[cIndex] = { ...c[cIndex], recentMessage: msg };
        const sorted = _.sortBy(c, (e) => e.recentMessage?.createdAt);
        setConversations(sorted.reverse());
      }
      // send acknowlegement that i've read message
      socket.emit('read', {
        from: user?._id,
        to: msg.senderId,
        msgIds: [msg._id]
      });
      return;
    }

    // Current user is Receiver
    // if chat is not open, then show  as recent Message in conv item
    if (user?._id === msg.receiverId) {
      const c = [...conversations];
      // change conversation recent message
      const cIndex = conversations.findIndex((c) => c.user._id === msg.senderId);
      if (cIndex > -1) {
        c[cIndex] = { ...c[cIndex], recentMessage: msg };
        const sorted = _.sortBy(c, (e) => e.recentMessage?.createdAt);
        setConversations(sorted.reverse());
        return;
      }
    }
    return;
  });

  socket.on('read', ({ from, to, msgIds }: { from: any, to: any, msgIds: any }) => {
    if (messages.filter((m) => m.read === false).length <= 0) {
      return;
    }

    if (selectedChat?.user._id === from) {
      const msgs = messages.map((m) => ({ ...m, read: true }));
      setMessages(msgs);
    }
    const c = [...conversations];
    const cIndex = conversations.findIndex((c) => c.user._id === from);
    if (cIndex < 0) return;
    const msg = c[cIndex].recentMessage;
    if (msg) {
      c[cIndex] = { ...c[cIndex], recentMessage: { ...msg, read: true } };
    }
    setConversations(c);
    return;
  });


  const handleSearch = (value: string) => {
    const items = conversations.filter((c) => c.user.name.toLowerCase().startsWith(value.toLowerCase()));
    if (items) {
      setSearchResults(items);
    } else {
      setSearchResults(conversations);
    }
  }

  if (!user) {
    return null;
  }
  return (
    <>
    <SEO 
      title="Inbox - Messages"
      description="View and manage your messages and conversations with tutors."
      keywords="inbox, messages, chat, conversations"
      url="/inbox"
      type="website"
      noIndex={true}
    />
    <div className="w-full min-h-screen flex flex-col bg-[#F5F6F9] px-4 md:p-10 py-5">
      <div className="w-full grow flex bg-white rounded-md">
        <div
          className={`w-full md:max-w-[30%] md:w-[30%] ${selectedChat ? 'md:block hidden' : 'block'
            } flex flex-col border-r shrink-0`}
        >
          <div className="h-16 flex items-center gap-4 p-4 border-b">
            <input
              type="text"
              placeholder="Search Name"
              className="w-full text-sm border border-primary outline-primary px-4 py-2 rounded-md"
            />
          </div>
          {searchResults.length > 0 ?
            <div className="flex flex-col p-4 overflow-scroll no-scrollbar">
              {searchResults.map((s) => (
                <>
                  <div
                    key={s._id}
                    onClick={() => setSelectedChat(s)}
                    className={`${selectedChat?.user?._id === s.user._id ? 'bg-gray-300' : 'bg-white'
                      } w-full flex gap-4 hover:bg-gray-100 rounded-md border-b p-4 cursor-pointer overflow-hidden`}
                  >
                    <img
                      src={s.user.profilePic || DEFAULT_PROFILE_PIC}
                      className="w-10 h-10 rounded-full shrink-0  object-cover overflow-hidden"
                    />
                    <div className="flex flex-col justify-center grow w-full min-w-0 basis-auto ">
                      <div className="flex items-center text-left">
                        <div className="flex grow overflow-hidden ">
                          <h3 className="text-base font-medium">{s.user.name}</h3>
                        </div>
                        {s.recentMessage && (
                          <p className={`text-xs whitespace-nowrap`}>
                            {format(parseJSON(s.recentMessage?.createdAt), 'p')}
                          </p>
                        )}
                      </div>
                      {s.recentMessage && (
                        <div className="flex items-center grow overflow-hidden overflow-ellipsis whitespace-nowrap">
                          <div className=" flex overflow-hidden overflow-ellipsis">
                            <p
                              className={`w-min text-sm whitespace-nowrap overflow-hidden overflow-ellipsis ${s.recentMessage.receiverId === user._id && !s.recentMessage.read
                                ? 'font-semibold'
                                : 'font-nornnal'
                                }`}
                            >
                              {s.recentMessage?.content}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              ))}
            </div>
            :
            <div className='min-h-[256px] flex flex-col items-center justify-center'>
              <h1 className='text-base font-semibold '>No Results Found </h1>
            </div>
          }
        </div>
        <div className="w-full flex grow flex-col">
          {selectedChat ? (
            <>
              <div className="h-16 w-full flex border-b p-4">
                <div
                  onClick={() => setSelectedChat(undefined)}
                  className="md:hidden w-8 h-8 flex items-center justify-center rounded-full p-2 cursor-pointer"
                >
                  <img src={BACK_ARROW} className="" />
                </div>{' '}
                <div className="flex items-center gap-4">
                  <img
                    src={selectedChat.user.profilePic || DEFAULT_PROFILE_PIC}
                    className="w-10 h-10 rounded-full object-cover overflow-hidden"
                  />
                  <div className="flex flex-col gap-1">
                    <h3 className="text-sm">{selectedChat.user.name}</h3>
                    {sessionDetails && (
                      <>
                        {sessionDetails.status === 'online' ? (
                          <p className="text-xs">Online</p>
                        ) : sessionDetails.lastSeen ? (
                          <p className="text-xs">Last seen {new Date(sessionDetails?.lastSeen).toLocaleString()}</p>
                        ) : null}
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div
                ref={chatBoxRef}
                className="grow relative w-full h-full max-h-[550px]  overflow-y-scroll list-scrollbar"
              >
                <div className="w-full h-full grow flex flex-col absolute  items-end">
                  <div className="w-full h-full flex-auto"></div>
                  <div className="flex-initial w-full h-full flex flex-col items-end grow py-4">
                    {messagesByDate.length > 0 ? (
                      <>
                        {messagesByDate.map((group) => (
                          <>
                            <div className="w-full">
                              <div className="w-min mx-auto flex items-center justify-center p-2 bg-[#F5F7FF] rounded-lg">
                                <p className="text-sm whitespace-nowrap">
                                  {format(parseJSON(new Date(group.date)), 'P')}
                                </p>
                              </div>
                            </div>
                            {group.messages.map((msg) => (
                              <div
                                key={msg._id}
                                className={`w-full ${msg.senderId === user._id ? 'ml-auto' : 'mr-auto'}`}
                              >
                                <div
                                  className={`max-w-[75%] min-w-[80px] w-full flex flex-col ${msg.senderId === user._id ? 'items-end ml-auto' : 'items-start mr-auto'
                                    } px-4 md:px-16 mb-3`}
                                >
                                  <div
                                    className={` flex flex-col p-2 ${msg.senderId === user._id ? 'bg-primary/40' : 'bg-[#F5F7FF]'
                                      } rounded-lg`}
                                  >
                                    <p className="text-sm break-all">{msg.content}</p>
                                    <div className="w-full flex items-end gap-1 justify-end -my-1">
                                      <p className="text-[11px]">{format(parseJSON(msg.createdAt), 'p')}</p>
                                      {msg.senderId === user._id && (
                                        <div className="w-4 h-4">
                                          {msg.status === 'pending' ? (
                                            <MdDone className="w-4 h-4 text-gray-300" />
                                          ) : (
                                            <MdDoneAll
                                              className={`w-4 h-4 ${msg.read ? 'text-primary' : 'text-gray-300'}`}
                                            />
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </>
                        ))}
                      </>
                    ) : (
                      <div className="w-full h-full grow flex items-center justify-center">
                        <div className="flex flex-col items-center justify-center gap-4">
                          <img src={NO_MESSAGES} className="w-20" />
                          <h3 className="text-xl font-medium">No Messages</h3>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="w-full flex flex-col gap-4 p-4 md:px-16 border-t">
                <form onSubmit={(e) => e.preventDefault()} className="w-full flex items-center gap-5">
                  <input
                    type="text"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Send Message"
                    className="w-full border-b px-4 py-2 outline-none"
                  />
                  <button
                    type="submit"
                    onClick={() => sendMessage()}
                    className="w-12 h-12 shrink-0 bg-secondary text-white flex items-center justify-center rounded-full"
                  >
                    <RiSendPlaneFill className="text-2xl" />
                  </button>
                </form>
                <div className="flex gap-2">
                  <MdInfo className="text-red-500 text-base" />
                  <p className="text-xs text-red-500">
                    You may not share any of your personal contact information with tutor on WorldOTutor. This includes
                    Phone number or Email address and Meeting link. Read terms of service
                  </p>
                </div>
              </div>
            </>
          ) : (
            <div className="hidden w-full h-full grow md:flex items-center justify-center">
              <div className="flex flex-col items-center justify-center gap-4">
                <img src={NO_MESSAGES} className="w-20" />
                <h3 className="text-xl font-medium">Select a chat to view messages</h3>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
    </>
  );
}
